










import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
    components: {
    },
})
export default class StCollapse extends Vue {
    @Prop()visible!:boolean;
    @Prop()noCloseAnimation!:boolean;

    get hasCloseAnimation(){
        return this.noCloseAnimation == undefined;
    }
}
